<template>
  <div class="cmpt-products-manufacture-edit-modal">
    <el-button type="primary" :loading="isLoading" @click="handleEntryBtnClick">编辑加工费</el-button>

    <el-dialog title="编辑加工费" :visible.sync="modalVisible" append-to-body width="50%">
      <el-form inline :model="form">
        <div
          class="flow item-box"
          v-for="(flow, flowIndex) in getRenderFlow(form.manufacture_flows)"
          :key="flow.id"
        >
          <div class="flex content-between item-center" style="margin-bottom: 10px">
            <div class="label-text">工序{{ flowIndex + 1 }}</div>
            <el-button
              v-if="form.manufacture_flows.length > 1"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="handleFlowRemove(flow, form.manufacture_flows)"
            />
          </div>

          <div
            class="material-relation item-box"
            v-for="(materialRelation, materialRelationIndex) in getRenderMaterialRelation(flow.manufacture_flow_material_relations)"
            :key="materialRelation.id"
          >
            <div class="flex content-between item-center">
              <div class="label-text">原料{{ materialRelationIndex + 1 }}</div>
              <el-button
                v-if="flowIndex === 0 && flow.manufacture_flow_material_relations.length > 1"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleMaterialRelationRemove(materialRelation, flow.manufacture_flow_material_relations)"
              />
            </div>

            <el-form-item label="SKU">
              <el-select
                v-model="materialRelation.sku"
                filterable
                placeholder="请输入关键词"
                remote
                size="small"
                :remote-method="materialRelationSkuRemoteMethod"
              >
                <el-option
                  v-for="sku in skus"
                  :key="sku.value"
                  :label="sku.label"
                  :value="sku.label"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="数量">
              <el-input size="small" v-model="materialRelation.qty" />
            </el-form-item>
          </div>

          <el-button
            v-if="flowIndex === 0"
            type="primary"
            icon="el-icon-plus"
            @click="handleMaterialRelationAdd(flow.manufacture_flow_material_relations)"
          >
            添加原料
          </el-button>

          <div class="processing-fee">
            <div class="label-text">加工费</div>

            <el-table border :data="flowProcessingPlantList[flowIndex].manufacture_flow_processing_plant_relation_table_attributes">
              <el-table-column prop="name" label="加工厂" />
              <el-table-column label="金额">
                <template slot-scope="scope">
                  <el-input size="small" v-model="scope.row.processing_charges" />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="handleFlowAdd"
        >
          添加工序
        </el-button>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModal">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import _ from 'lodash';

  @Component
  export default class ManufactureEditModal extends Vue {
    @Prop(Object) row

    form = {
      manufacture_flows: [],
    }

    handleFlowAdd() {
      const flowId = `new-${Date.now()}`;
      const materialId = `new-${Date.now() + 5}`;
      const item = {
        flowId,
        manufacture_flow_processing_plant_relation_table_attributes: this.companies.map(company => ({
          processing_plant_id: company.value,
          processing_charges: '',
          name: company.label,
        }))
      };
      this.form.manufacture_flows.push({
        id: flowId,
        manufacture_flow_material_relations: [
          { id: materialId }
        ],
        manufacture_flow_processing_plant_relations: []
      });
      this.flowProcessingPlantList.push(item);
    }
    async handleFlowRemove(flow, flows) {
      await this.$confirm('确定要删除?');
      // 移除加工费列表中的工序
      const processingPlantIndex = this.flowProcessingPlantList.findIndex(v => v.flowId === flow.id);
      this.flowProcessingPlantList.splice(processingPlantIndex, 1);

      // 移除表单中的工序
      if (typeof flow.id === 'string' && flow.id.startsWith('new-')) {
        const index = flows.findIndex(v => v.id === flow.id);
        flows.splice(index, 1);
      } else {
        this.$set(flow, '_destroy', true);
      }
    }
    // 过滤已删除的工序
    getRenderFlow(flows) {
      return flows.filter(v => typeof v._destroy === 'undefined' || v._destroy !== true);
    }

    // 过滤已删除的原料
    getRenderMaterialRelation(materialRelations) {
      return materialRelations.filter(v => typeof v._destroy === 'undefined' || v._destroy !== true);
    }

    companies = []
    isLoading = false
    isCompanyLoaded = false
    async fetchCompanies(force = false) {
      if (this.isCompanyLoaded) {
        if (!force) {
          return Promise.resolve();
        }
      }
      this.isLoading = true;
      this.isCompanyLoaded = false;
      const { data } = await this.$request.get('/companies/read_options', { per_page: 100 });
      this.companies = data.map(v => ({ label: v.name, value: v.id }));
      this.isLoading = false;
      this.isCompanyLoaded = true;
    }
    /**
     * 工序数组, 里面包含对应的加工费数组
     * e.g. [{ flowId: 工序id, manufacture_flow_processing_plant_relation_table_attributes: [{ processing_plant_id: 工厂id, processing_charges: 加工费, name: 工厂名 }] }]
     */
    flowProcessingPlantList = []
    @Watch('modalVisible')
    async initForm(newVisible, oldVisible) {
      if (oldVisible !== newVisible && newVisible) {
        // 初始化工序
        this.form.manufacture_flows = _.cloneDeep(this.row.manufacture_flows);
        // 初始化所有工序的加工费
        this.flowProcessingPlantList = this.row.manufacture_flows.map(flow => {
          const manufacture_flow_processing_plant_relation_table_attributes = this.companies.map(company => {
            const processingPlant = flow.manufacture_flow_processing_plant_relations.find(v => v.processing_plant_id === company.value);

            return {
              processing_plant_id: company.value,
              processing_charges: processingPlant === undefined ? undefined : processingPlant.processing_charges,
              name: company.label,
            };
          });

          return { flowId: flow.id, manufacture_flow_processing_plant_relation_table_attributes };
        });
      }
    }

    skus = []
    async fetchSkus(keyword) {
      const { data } = await this.$request.get('/materials/read_options', { per_page: 100, keyword });
      this.skus = data.map(v => ({ label: v.sku, value: v.id }));
    }
    materialRelationSkuRemoteMethod(query) {
      if (!query) {
        this.skus = [];
      }

      this.fetchSkus(query);
    }

    handleMaterialRelationAdd(materialRelation) {
      materialRelation.push({ id: `new-${Date.now()}` });
    }
    async handleMaterialRelationRemove(materialRelation, materialRelations) {
      await this.$confirm('确定要删除?');
      if (typeof materialRelation.id === 'string' && materialRelation.id.startsWith('new-')) {
        const index = materialRelations.findIndex(v => v.id === materialRelation.id);
        materialRelations.splice(index, 1);
      } else {
        this.$set(materialRelation, '_destroy', true);
      }
    }

    modalVisible = false
    openModal() {
      this.modalVisible = true;
    }
    closeModal() {
      this.modalVisible = false;
    }
    async handleEntryBtnClick() {
      // 获取所有加工厂
      await this.fetchCompanies();
      this.openModal();
    }

    async handleSubmit() {
      const manufacture_flows = this.form.manufacture_flows.map(flow => {
        /** 原料 */
        const manufacture_flow_material_relations = flow.manufacture_flow_material_relations.map(material => {
          if (!_.hasIn(material, '_destroy')) {
            if (typeof material.id === 'string' && material.id.startsWith('new-')) {
              return { sku: material.sku, qty: material.qty };
            }

            return { id: material.id, sku: material.sku, qty: material.qty };
          }

          return { id: material.id, sku: material.sku, qty: material.qty, _destroy: material._destroy };
        });

        const flowProcessingPlantItem = this.flowProcessingPlantList.find(item => {
          return item.flowId === flow.id
        });
        /** 加工费 */
        const manufacture_flow_processing_plant_relation_table_attributes = flowProcessingPlantItem === undefined
          ? []
          : flowProcessingPlantItem.manufacture_flow_processing_plant_relation_table_attributes.map(v => ({
              processing_plant_id: v.processing_plant_id,
              processing_charges: v.processing_charges
            }));

        if (!_.hasIn(flow, '_destroy')) {
          if (typeof flow.id === 'string' && flow.id.startsWith('new-')) {
            return { manufacture_flow_material_relations, manufacture_flow_processing_plant_relation_table_attributes };
          }

          return { id: flow.id, manufacture_flow_material_relations, manufacture_flow_processing_plant_relation_table_attributes };
        }

        return {
          id: flow.id,
          manufacture_flow_material_relations,
          manufacture_flow_processing_plant_relation_table_attributes,
          _destroy: flow._destroy
        };
      });
      await this.$autoLoading(this.$request.put(`/variants/${this.row.id}`, { manufacture_flows }));
      this.closeModal();
      this.$emit('reload');
      this.$message.success(this.$t('operateSuccess'));
    }
  }
</script>

<style lang="scss" scoped>
  .item-box {
    padding: 10px;
    border: 1px solid #ddd;

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &.flow {
      margin-left: 0;
    }
  }

  .processing-fee {
    padding: 10px;
    margin-top: 10px;
    border: 1px solid #ddd;
  }

  .label-text {
    font-weight: bold;
  }
</style>
